import { useMemo } from 'react';
import { InteractionStatus } from '@azure/msal-browser';
import { Stack, Text } from 'buzz_lib_ui';
import { jsx as _jsx } from "react/jsx-runtime";
export const AuthLoadingComponent = _ref => {
  let {
    status
  } = _ref;
  const text = useMemo(() => getInteractionStatusText(status), [status]);
  return /*#__PURE__*/_jsx(Stack, {
    horizontal: true,
    verticalAlign: "center",
    tokens: {
      childrenGap: 10,
      padding: 10
    },
    children: /*#__PURE__*/_jsx(Text, {
      variant: "large",
      children: text
    })
  });
};
const getInteractionStatusText = status => {
  switch (status) {
    case InteractionStatus.Startup:
      {
        return 'Starting authorization...';
      }
    case InteractionStatus.HandleRedirect:
      {
        return 'Completing sign-in...';
      }
    case InteractionStatus.Logout:
      {
        return 'Signing out...';
      }
    case InteractionStatus.AcquireToken:
      {
        return 'Acquiring token...';
      }
    case InteractionStatus.None:
    default:
      {
        return 'Loading authorization data...';
      }
  }
};